<template>
  <q-input
    v-bind="$attrs"
    ref="field"
    :type="type"
    :rows="type === 'textarea' ? 3 : undefined"
    :readonly="readonly"
    :model-value="modelValue"
    :outlined="outlined"
    :borderless="borderless"
    :placeholder="placeholder"
    :dense="dense"
    :label="label"
    :stack-label="stackLabel"
    :debounce="50"
    :disable="disable"
    :loading="isLoading"
    :error="error"
    :error-message="errorMessage"
    @update:model-value="onInput"
    @focus="openMenu"
  >
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend" />
    </template>
    <q-menu
      v-if="!disable && !readonly && (canCreate || filteredInventory.length > 0)"
      ref="menu"
      v-model="focused"
      fit
      no-focus
      no-refocus
      no-parent-event
    >
      <q-card>
        <q-list separator>
          <template v-if="canCreate">
            <clickable-item
              v-close-popup
              label="Create New Inventory Item"
              @click="$refs.addInventoryDialog.open(null, true)"
            />

            <slot name="create" />
          </template>

          <InventoryInputItem
            v-for="(item, key) in filteredInventory"
            :key="key"
            :item="item"
            :selected="selected"
            :dense="!$q.platform.has.touch"
            @click="onClickDropdownItem(item)"
          />
        </q-list>
      </q-card>
    </q-menu>
    <template #append>
      <slot name="append" />
    </template>
  </q-input>

  <AddInventoryDialog
    ref="addInventoryDialog"
    @created="onClickDropdownItem($event)"
  />
</template>

<script>
import InventoryInputItem from './InventoryInputItem'
import Fuse from 'fuse.js'
import AddInventoryDialog from 'components/app/inventory/Add.vue'

export default {
  components: {
    AddInventoryDialog,
    InventoryInputItem
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String
    },
    selected: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    stackLabel: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    restrictType: {
      type: Array,
      default: null
    },
    restrictSystemType: {
      type: Array,
      default: null
    },
    // Show default list of results if no search text is entered
    withDefaultResults: {
      type: Boolean,
      default: false
    },
    // Number of results to return
    numResults: {
      type: Number,
      default: 10
    },
    // Is error
    error: {
      type: Boolean,
      default: false
    },
    // Error message if applicable
    errorMessage: {
      type: String,
      default: undefined
    },
    type: {
      type: String
    },
    canCreate: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'select'],
  data () {
    return {
      focused: false
    }
  },
  computed: {
    inventory () {
      let inventory = this.$store.getters['inventory/getInventory']

      // Apply filters if they exist
      if (this.restrictType || this.restrictSystemType) {
        inventory = inventory.filter(item => {
          return (!this.restrictType || this.restrictType.includes(item.type)) &&
            (!this.restrictSystemType || this.restrictSystemType.includes(item.system_type_id))
        })
      }

      return new Fuse(inventory, {
        keys: ['code', 'name', 'description', 'selling_unit_price']
      })
    },
    filteredInventory () {
      if (!this.modelValue) {
        return this.withDefaultResults ? this.inventory._docs.slice(0, this.numResults) : []
      }
      return this.inventory.search(this.modelValue, {
        limit: this.numResults
      }).map(i => i.item)
    },
    isLoading () {
      return this.$store.getters['inventory/isLoading'] || this.loading
    }
  },
  methods: {
    openMenu () {
      this.focused = true
      this.$store.dispatch('inventory/getInventory').then(() => {
        this.updatePosition()
      })
    },
    onInput (val) {
      this.$emit('update:modelValue', val)
      this.timed(() => {
        this.updatePosition()
      })
    },
    focus () {
      this.focused = true
      this.$refs.field.focus()
    },
    blur () {
      this.focused = false
      this.$refs.field.blur()
    },
    updatePosition () {
      if (this.$refs.menu) {
        this.$refs.menu.updatePosition()
      }
    },
    onClickDropdownItem (item) {
      this.$emit('select', item)
      this.blur()
    }
  },
  mounted () {
    if (this.autofocus) {
      this.timed(() => {
        this.focus()
      })
    }
  }
}
</script>
